import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ApiKey } from "types/generated";

import { getPersonalApiKeyIssue } from "../../helpers";
import PersonalApiKeysIssueBadge from "../../IssueBadge";

const PersonalApiKeysTableIssuesCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<
  Pick<ApiKey, "disabled" | "disabledAt" | "disabledReason" | "expiresAt">
>) => {
  const issue = getPersonalApiKeyIssue(apiKey);

  return (
    <TableSimpleCell {...cellProps}>
      {issue && <PersonalApiKeysIssueBadge issue={issue} apiKey={apiKey} />}
      {!issue && <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableIssuesCell;
